import { useQueryClient } from '@tanstack/react-query'

import { ClientError } from '@tribeplatform/gql-client/lib'
import {
  Chat,
  MutationRemoveMembersFromGroupArgs,
} from '@tribeplatform/gql-client/types'

import {
  UseMutationOptions,
  useMutation,
} from '../../lib/react-query/useMutation.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getChatParticipantsKey } from '../../utils/keys/messaging.key.js'

export const useRemoveChatParticipants = (
  options?: UseMutationOptions<
    Chat,
    ClientError,
    MutationRemoveMembersFromGroupArgs
  >,
) => {
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<Chat, ClientError, MutationRemoveMembersFromGroupArgs>(
    (input: MutationRemoveMembersFromGroupArgs) =>
      client.messaging.removeGroupChatParticipants(input),
    {
      ...(options ?? {}),
      onSuccess: async (data, variables, context) => {
        const chatParticipantsKey = getChatParticipantsKey({
          variables: { chatId: variables.chatId },
        })

        await queryClient.invalidateQueries(chatParticipantsKey)
        if (options?.onSuccess) {
          options.onSuccess(data, variables, context)
        }

        return data
      },
    },
  )
}
